import { render, staticRenderFns } from "./OtaPickers.vue?vue&type=template&id=360d68a2&scoped=true&"
import script from "./OtaPickers.vue?vue&type=script&lang=js&"
export * from "./OtaPickers.vue?vue&type=script&lang=js&"
import style0 from "./OtaPickers.vue?vue&type=style&index=0&id=360d68a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d68a2",
  null
  
)

export default component.exports